import * as React from 'react';
import { useState } from 'react';
import { Button, Field, RefreshIcon, Table, Toolbar } from 'react-unity';
import Paginator from '../common/tables/Paginator';
import AWSAPermissionInfo from '../../models/entities/AWSPermissionInfo';
import AwsSSOHomeTableRow from './AwsSSOHomeTableRow';

interface AwsSSOHomeTableRowProps {
	assignedPermissions: AWSAPermissionInfo[];
	setConfirmModalVisible: (e) => void;
	setPermissionsSelected: (e) => void;
	handleRefresh: () => void;
	operationInProgress: boolean;
}

const AwsSSOHomeTable = ({
	assignedPermissions,
	setConfirmModalVisible,
	setPermissionsSelected,
	handleRefresh,
	operationInProgress
} : AwsSSOHomeTableRowProps) => {

	const [pageRows, setPageRows] = useState(1);

	const handlePageChange = (page: any) => {
		setPageRows(page);
	};

	return (
		<Field>
			<Field.Body>
				<Table
					header={
						<Toolbar id="toggle-toolbar">
							<Toolbar.Item className="searchbar-width">
								<Button variant="secondary" size="small" onClick={handleRefresh}>
									<RefreshIcon size="small" />
									<span> Refresh</span>
								</Button>
							</Toolbar.Item>
						</Toolbar>
					}
					footer={
						<Paginator
							data={assignedPermissions}
							onPageChange={handlePageChange}
						/>
					}
				>
					<Table.Head>
						<Table.Head.Row>
							<Table.Head.Cell> Permission Name </Table.Head.Cell>
							<Table.Head.Cell> Group Name</Table.Head.Cell>
							<Table.Head.Cell> Group Id</Table.Head.Cell>
							<Table.Head.Cell> Action </Table.Head.Cell>
							<Table.Head.Cell>
							</Table.Head.Cell>
						</Table.Head.Row>
					</Table.Head>
					<Table.Body>
						{assignedPermissions.length > 0 ?
							<>
							{assignedPermissions.map((assignedPermission, index) => 
								<AwsSSOHomeTableRow
									index={index}
									assignedPermission={assignedPermission}
									setConfirmModalVisible={setConfirmModalVisible}
									setPermissionsSelected={setPermissionsSelected}
									operationInProgress={operationInProgress}
								/>
							)}
							</>
							:
							<Table.Body.Row>
								<Table.Body.Cell
									colSpan={2}
								>
									<i>No permissions found.</i>
								</Table.Body.Cell>
							</Table.Body.Row>}
					</Table.Body>
				</Table>
			</Field.Body>
		</Field>
	);
};

export default AwsSSOHomeTable;